import HeaderNav from "../../Components/Header/Header_Nav/Header_Nav";
import Footer from "../../Components/Footer/Footer";
import "./ColorPop.css"

function ColorPop() {

    return(

        <div>
            <HeaderNav GoBack_to="/"/>

            <div className = "content-container-colorpop">
                
                {/* Game Board */}
                <div className = "table-container-colorpop"
                    //  will use inline
                     style= {{

                                                height: "auto",
                        margin: "0 auto",
                        marginTop: "30px",
                        display: "flex",
                        height: "70vh", 
                        width: "110vh", 
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        justifyContent: "center",
                        paddingTop: "2rem",       
                        overflow: "hidden",
                        position: "relative",
                        transition: "background-image 1s ease-in-out",
                        border: "7px solid pink",
                        borderRadius: "12px",


                     }}
                >

                </div>

            </div>

            <Footer/>
        </div>

    );

}

export default ColorPop;